import { reportErrorToFaro } from '@sendible/common';

const QueueModel = Backbone.Model.extend({
  defaults: {
    queue_name: 'New Queue',
    auto_detect: 0,
    can_repeat: 0,
    is_paused: 0,
    queue_times: [],
  },
  initialize() {
    this.defaults.queue_name = window.lookup('New queue');
  },
  getQueueTimesString(model) {
    const queueTimes = [];
    for (let i = 0; i < model.attributes.queue_times.length; i++) {
      // According to API spec at https://code.google.com/p/sendible-api/wiki/UpdateQueue
      // format for passing queue times to API is day_index|hour|minute,day_index|hour|minute,....,day_index|hour|minute
      queueTimes.push(`${model.attributes.queue_times[i].weekday}|${model.attributes.queue_times[i].hour}|${model.attributes.queue_times[i].minute}`);
    }
    return queueTimes.join(',');
  },
  sync(method, model, options) {
    // Possible methods: create, read, update, dete
    const queue = {
      auto_detect: model.attributes.auto_detect,
      can_repeat: model.attributes.can_repeat,
      is_paused: model.attributes.is_paused ? 1 : 0,
      queue_id: model.attributes.id || model.attributes.queue_id,
      queue_name: model.attributes.queue_name,
      queue_times: this.getQueueTimesString(model),
      contributors: '',
    };

    if (model.attributes.paused_until) {
      try {
        const dateFormat = `YYYY/MM/DD ${$current_user.clock_format == 24 ? 'HH:mm' : 'hh:mma'}`;
        const momentPausedUntil = moment.utc(model.attributes.paused_until, dateFormat);
        const modifiedDate = momentPausedUntil.utcOffset($current_user.timezone).format('YYYY/MM/DD HH:mm');

        queue.paused_until = modifiedDate;
      } catch (error) {
        reportErrorToFaro(error, 'QueueModel');

        queue.paused_until = null;
      }
    }

    if (model.attributes.contributors) {
      if (typeof model.attributes.contributors === 'string') {
        queue.contributors = model.attributes.contributors;
      } else {
        queue.contributors = _.pluck(_.pluck(model.attributes.contributors, 'user'), 'id').join(',');
      }
    }

    if (method == 'read') {
      return Sendible.Connect.getQueue(window.appConfig.applicationId, $username, $password, { queue_id: queue.queue_id }, (result) => {
        if (result.paused_until) {
          const momentPausedUntil = moment.utc(result.paused_until);
          const pausedUntilWithOffset = momentPausedUntil.utcOffset(-($current_user.timezone));
          const timeFormat = $current_user.clock_format == 24 ? 'HH:mm' : 'hh:mma';

          options.success({
            ...result,
            paused_until: pausedUntilWithOffset.format(`YYYY/MM/DD ${timeFormat}`),
          });
        } else {
          options.success(result);
        }
      });
    } if (method == 'update') {
      return Sendible.Connect.saveQueue(
        window.appConfig.applicationId,
        $username,
        $password,
        queue,
        (result) => {
          options.success(result);
          // model.trigger('sync', model, result, options);
        },
        (result) => {
          options.error(result);
        },
      );
    } if (method == 'create') {
      return Sendible.Connect.saveQueue(
        window.appConfig.applicationId,
        $username,
        $password,
        queue,
        (result) => {
          options.success(result);
          // model.trigger('sync', model, result, options);
        },
        (result) => {
          options.error(result);
        },
      );
    } if (method == 'delete') {
      Sendible.Connect.deleteQueue(
        window.appConfig.applicationId,
        $username,
        $password,
        queue,
        (result) => {
          // model.trigger('sync', model, result, options);
          options.success(result);
        },
        () => {},
      );
    }
  },
});

export default QueueModel;
